/**
 * Work permission keys (catalog `work.*`, docs/contracts/tasks-and-forms.md §6). Filling a form or ticking a checklist
 * on a record needs the record type's own update key; the API checks the same keys.
 */
export const workPermissions = {
  taskView: "work.task.view",
  taskCreate: "work.task.create",
  taskUpdate: "work.task.update",
  taskHistory: "work.task.history",
  taskManage: "work.task.manage",
  queueUpdate: "work.task_queue.update",
  formView: "work.form.view",
  formCreate: "work.form.create",
  formUpdate: "work.form.update",
  checklistView: "work.checklist_template.view",
  checklistCreate: "work.checklist_template.create",
  checklistUpdate: "work.checklist_template.update",
} as const;

/** Plan module of Tasks & Forms (always on). */
export const workModule = "work";

/** The task settings group (`/platform/settings/work`). */
export const workSettingsGroup = "work";

/** Record type of a task (links, forms and checklists on a task). */
export const taskRecordType = "work.task";
